export default "__VITE_ASSET__2b0c1139__"